export default function($stateProvider) {
  'ngInject';

  $stateProvider.state('noAuth', {
    abstract: true,
    component: 'fizyPaycellNoAuth',
    parent: 'app'
  });  
}


// WEBPACK FOOTER //
// ./src/app/no-auth/no-auth.routes.ts